import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// Real translations for the football club website
const resources = {
  cs: {
    translation: {
      // Navigation
      nav: {
        home: "Domů",
        matches: "Zápasy",
        calendar: "Kalendář",
        tables: "Tabulky",
        players: "Hráči",
        gallery: "Galerie",
        videos: "Videa",
        articles: "Články",
        activities: "Aktivity",
        contact: "Kontakt",
        shop: "E-shop",
        sponsors: "Sponzoři",
        club: "Klub",
        news: "Aktuality",
        all_articles: "Další články",
        all_matches: "Všechny zápasy",
        all_tables: "Zobrazit vše",
        login: "Přihlásit se",
        register: "Registrovat se",
        admin: "Administrace",
        logout: "Odhlásit",
        view_all: "Zobrazit vše"
      },
      
      // Homepage sections
      homepage: {
        nearest_matches: "Nejbližší zápasy",
        latest_news: "Aktuality",
        latest_title: "Nejnovější titulek",
        more_articles_home: "Další aktuality",
        tables: "Tabulky",
        gallery: "Photos",
        sponsors: "Partneři",
        shop: "Fanshop",
        calendar: "Kalendář",
        activities: "Aktivity",
        videos: "Videa",
        club: "Klub",
        contact: "Kontakt",
        welcome_to_club: "Vítejte v našem fotbalovém klubu",
        official_website: "Oficiální web klubu",
        read_more: "Číst více",
        view_all: "Zobrazit vše",
        next_match: "Příští zápas",
        match_details: "Detail zápasu",
        competition: "Soutěž",
        venue: "Místo konání",
        result: "Výsledek",
        standings: "Tabulka",
        position: "Poz.",
        team: "Tým",
        points: "Body",
        played: "Zápasy",
        won: "V",
        drawn: "R",
        lost: "P",
        goals: "Góly",
        goal_difference: "Rozdíl",
        latest_results: "Poslední výsledky",
        upcoming_events: "Nadcházející akce",
        featured_articles: "Doporučené články",
        more_articles: "Další články",
        photo_gallery: "Photos",
        video_gallery: "Video galerie",
        our_partners: "Naši partneři",
        more_videos: "Více videí",
        all_matches: "Všechny zápasy",
        partner_categories: {
          general: "Generální partner",
          main: "Hlavní partner",
          official: "Oficiální partner",
          media: "Mediální partner",
          technical: "Technický partner",
          supplier: "Dodavatel"
        }
      },
      
      // News section
      news: {
        no_news: "Zatím nejsou k dispozici žádné aktuality.",
        view_all_news: "Zobrazit všechny aktuality"
      },
      
      // Common actions
      action: {
        save: "Uložit",
        edit: "Upravit",
        delete: "Smazat",
        add: "Přidat",
        create: "Vytvořit",
        update: "Aktualizovat",
        cancel: "Zrušit",
        confirm: "Potvrdit",
        close: "Zavřít",
        back: "Zpět",
        next: "Další",
        previous: "Předchozí",
        search: "Hledat",
        filter: "Filtrovat",
        sort: "Seřadit",
        loading: "Načítám...",
        error: "Chyba",
        success: "Úspěch",
        warning: "Varování",
        info: "Informace",
        view: "Zobrazit",
        download: "Stáhnout",
        upload: "Nahrát",
        share: "Sdílet",
        copy: "Kopírovat",
        send: "Odeslat",
        submit: "Odeslat",
        reset: "Resetovat",
        refresh: "Obnovit",
        open: "Otevřít",
        close_window: "Zavřít okno",
        continue: "Pokračovat",
        finish: "Dokončit",
        start: "Začít",
        stop: "Zastavit",
        pause: "Pauza",
        resume: "Pokračovat",
        select: "Vybrat",
        choose: "Vybrat",
        clear: "Vymazat",
        apply: "Použít",
        ok: "OK",
        yes: "Ano",
        no: "Ne",
        more: "Další",
        open_menu: "Otevřít menu",
        content_admin: "Správa obsahu",
        play: "Přehrát",
        open_on_youtube: "Otevřít na YouTube"
      },
      
      // Messages and notifications
      message: {
        loading: "Načítám...",
        saving: "Ukládám...",
        saved: "Uloženo",
        deleted: "Smazáno",
        updated: "Aktualizováno",
        created: "Vytvořeno",
        error_occurred: "Došlo k chybě",
        success_message: "Operace proběhla úspěšně",
        confirm_delete: "Opravdu chcete smazat tuto položku?",
        no_data_found: "Žádná data nenalezena",
        network_error: "Chyba sítě",
        server_error: "Chyba serveru",
        validation_error: "Chyba validace",
        permission_denied: "Přístup zamítnut",
        page_not_found: "Stránka nenalezena",
        session_expired: "Relace vypršela",
        login_required: "Vyžadováno přihlášení",
        invalid_credentials: "Neplatné přihlašovací údaje",
        email_sent: "E-mail odeslán",
        email_error: "Chyba při odesílání e-mailu",
        file_uploaded: "Soubor nahrán",
        file_error: "Chyba při nahrávání souboru",
        image_uploaded: "Obrázek nahrán",
        image_error: "Chyba při nahrávání obrázku"
      },
      
      // Footer
      footer: {
        articles: "Články",
        matches: "Zápasy",
        table: "Tabulka",
        sponsors: "Sponzoři",
        contact: "Kontakt",
        cookies: "Cookies",
        terms: "Obchodní podmínky",
        privacy: "Zásady ochrany osobních údajů",
        eshop: "E‑shop",
        partners: "Naši partneři",
        follow_us: "Sledujte nás",
        copyright: "© {year} {club}. Všechna práva vyhrazena.",
        all_rights_reserved: "Všechna práva vyhrazena {year}",
        powered_by: "Stránku provozuje MyClub",
        powered_by_desc: "Profesionální webové stránky pro sportovní kluby",
        order_now: "Objednat",
        learn_more: "Zjistit více",
        quick_links: "Rychlé odkazy",
        contact_info: "Kontaktní informace",
        address: "Adresa",
        phone: "Telefon",
        email: "E-mail",
        opening_hours: "Otevírací doba"
      },
      
      // Search page
      search: {
        title: "Vyhledávání",
        description: "Prohledávejte kluby, zápasy, články, hráče, akce a další obsah",
        placeholder: "Hledat...",
        search_button: "Vyhledat",
        search_error: "Chyba vyhledávání",
        error_title: "Chyba při vyhledávání",
        no_results: "Žádné výsledky",
        no_results_desc: "Pro dotaz \"{query}\" nebyly nalezeny žádné výsledky",
        try_different: "Zkuste jiné klíčové slovo nebo hledejte obecnější termín",
        searching: "Hledám...",
        filters: "Filtry",
        results: "výsledky",
        search_hint: "Zadejte klíčová slova pro vyhledávání",
        loading: "Vyhledávám...",
        all: "Vše",
        clubs: "Kluby",
        matches: "Zápasy",
        articles: "Články",
        players: "Hráči",
        events: "Akce",
        others: "Ostatní",
        upcoming_matches: "Nadcházející zápasy",
        past_matches: "Minulé zápasy",
        show_all_clubs: "Zobrazit všech {count} klubů",
        show_all_players: "Zobrazit všech {count} hráčů",
        show_all_matches: "Zobrazit všechny zápasy",
        show_all_articles: "Zobrazit všech {count} článků",
        show_all_events: "Zobrazit všechny akce",
        no_clubs_found: "Žádné kluby nenalezeny",
        no_matches_found: "Žádné zápasy nenalezeny",
        no_articles_found: "Žádné články nenalezeny",
        no_players_found: "Žádní hráči nenalezeni",
        no_events_found: "Žádné akce nenalezeny",
        no_sponsors_found: "Žádní sponzoři nenalezeni",
        no_contacts_found: "Žádné kontakty nenalezeny",
        no_gallery_found: "Žádná galerie nenalezena",
        no_categories_found: "Žádné kategorie nenalezeny",
        teams: "Týmy",
        sponsors: "Sponzoři",
        contacts: "Kontakty",
        gallery: "Galerie",
        photos: "fotek",
        no_other_results: "Žádné další výsledky"
      },
      
      // Tables page
      tables: {
        select_club: "Vyberte klub pro zobrazení tabulky soutěže.",
        loading_table: "Načítám tabulku...",
        table_error: "Chyba při načítání tabulky",
        rank: "#",
        team: "Tým",
        played: "Z",
        wins: "V",
        draws: "R",
        losses: "P",
        score: "Skóre",
        points: "Body",
        position_place: "{{position}}. místo"
      },
      
      // Club modal
      club_modal: {
        statistics: "Statistiky",
        matches_played: "Odehráno zápasů",
        wins: "Výhry",
        draws: "Remízy",
        losses: "Prohry",
        score: "Skóre",
        goals_scored: "Vstřelené góly",
        goals_conceded: "Obdržené góly",
        goal_difference: "Rozdíl skóre",
        points: "Body",
        form_last_5: "Forma (posledních 5 zápasů)",
        close: "Zavřít"
      },
      
      // Calendar page
      calendar: {
        title: "Kalendář",
        subtitle: "Přehled zápasů podle soutěží (FACR).",
        loading: "Načítám rozpis…",
        no_matches: "Zatím nemáme žádné zápasy k zobrazení.",
        check_settings: "Zkontrolujte nastavení klubu v administraci",
        all_competitions: "Všechny soutěže",
        month_view: "Měsíční pohled",
        week_view: "Týdenní pohled",
        today: "Dnes",
        no_events: "Žádné akce",
        match: "Zápas",
        event: "Akce",
        training: "Trénink",
        competition: "Soutěž",
        venue: "Místo konání",
        result: "Výsledek",
        upcoming: "Nadcházející",
        past: "Minulé",
        activities_title: "Aktivity",
        activities_subtitle: "Kalendář tréninků, schůzek a dalších klubových aktivit.",
        all_types: "Všechny typy",
        no_activities: "Zatím nemáme žádné aktivity k zobrazení.",
        oldest_first: "Nejstarší první",
        list_view: "Seznam",
        calendar_view: "Kalendář",
        club: "Klub",
        matches_filter: "Zápasy",
        training_filter: "Tréninky", 
        meeting_filter: "Schůzky",
        other_filter: "Ostatní",
        previous_month: "Předchozí měsíc",
        next_month: "Další měsíc",
        loading_activities: "Načítám aktivity…",
        match_type: "Zápas",
        training_type: "Trénink",
        meeting_type: "Schůzka",
        other_type: "Jiné",
        more_events: "+{count} další…",
        win: "Výhra",
        draw: "Remíza", 
        loss: "Prohra",
        show_more: "+{count} další…",
        show_less: "Zobrazit méně",
        show_past_matches: "Zobrazit předchozí zápasy ({count})",
        hide_past_matches: "Skrýt předchozí zápasy"
      },
      
      // Players page
      players: {
        title: "Hráči",
        search_placeholder: "Hledat jméno, číslo, pozici",
        gender: "Pohlaví",
        position: "Pozice",
        active_only: "Pouze aktivní",
        male: "Muž",
        female: "Žena",
        loading_error: "Chyba při načítání hráčů"
      },
      
      // Blog page
      blog: {
        title: "Blog",
        search_articles: "Hledat články…",
        search_match: "Hledat zápas…",
        all_categories: "Všechny kategorie",
        loading: "Načítání…",
        category: "Kategorie",
        publish_date: "Datum publikace",
        read_time: "Doba čtení",
        search_results: "Výsledky hledání článků pro „{query}“.",
        category_articles: "Články v kategorii {category}.",
        latest_articles: "Nejnovější články, rozhovory a novinky z klubu.",
        match: "Zápas",
        subscribe: "Přihlaste se k odběru novinek",
        subscribe_description: "Budeme vás informovat o novinkách, zápasech a akcích našeho klubu. Současně pro vás vytvoříme fanouškovský účet a pošleme heslo e‑mailem.",
        email_label: "Váš e-mail",
        consent_text: "Odesláním formuláře souhlasíte se zpracováním osobních údajů. Z odběru se můžete kdykoli odhlásit a nastavení upravit v zaslaném e‑mailu. Heslo lze změnit přes stránku pro obnovení hesla.",
        subscribe_button: "Odeslat"
      },
      
      // Videos page
      videos: {
        title: "Videa",
        description: "Sledujte naše nejnovější videa a zápasy.",
        loading: "Načítám videa...",
        watch_latest: "Sledujte naše nejnovější videa a zápasy",
        all_from_youtube: "Všechna videa jsou z YouTube",
        no_videos: "Zatím nejsou k dispozici žádná videa",
        play: "Přehrát",
        youtube_channel: "YouTube kanál",
        open_on_youtube: "Otevřít na YouTube",
        more_videos: "Více videí"
      },
      
      // Sponsors page
      sponsors: {
        title: "Naši partneři",
        main_partners: "Hlavní partneři",
        partners: "Partneři",
        become_partner: "Staňte se partnerem klubu",
        partnership_description: "Máte zájem o spolupráci, reklamu nebo podporu klubu? Napište nám pár informací a my se vám ozveme zpět.",
        name_label: "Jméno a příjmení *",
        name_placeholder: "Jan Novák",
        name_required: "Vyplňte prosím jméno",
        email_label: "E‑mail *",
        email_placeholder: "vas@email.cz",
        email_required: "Vyplňte prosím e‑mail",
        subject_label: "Předmět *",
        subject_placeholder: "Partnerství, reklama, podpora...",
        subject_required: "Předmět je povinný",
        message_label: "Zpráva *",
        message_placeholder: "Stručně nám napište, o jakou spolupráci máte zájem...",
        message_required: "Napište prosím krátkou zprávu",
        sending: "Odesílám...",
        send_message: "Odeslat zprávu",
        message_sent: "Zpráva odeslána",
        message_sent_desc: "Děkujeme za zprávu.",
        error_loading: "Chyba při načítání sponzorů",
        timeout_error: "Vypršel časový limit požadavku. Zkuste to prosím znovu.",
        network_error: "Požadavek se nezdařil (síť/CORS). Obnovte stránku a zkuste znovu.",
        send_error: "Odeslání se nezdařilo",
        error_title: "Chyba"
      },
      
      // Contact page
      contact: {
        title: "Kontakt",
        contact_info: "Kontaktní údaje",
        address: "Adresa",
        phone: "Telefon",
        email: "Email",
        contact_persons: "Kontaktní osoby",
        others: "Ostatní",
        no_contacts: "Pro tuto kategorii zatím nemáme kontaktní osobu.",
        contact_us: "Kontaktujte nás",
        contact_description: "Máte dotaz nebo připomínku? Napište nám zprávu a my se vám ozveme co nejdříve zpět.",
        name_label: "Jméno a příjmení *",
        name_placeholder: "Jan Novák",
        name_required: "Toto pole je povinné",
        name_min_length: "Jméno musí mít alespoň 2 znaky",
        email_label: "E-mailová adresa *",
        email_placeholder: "vas@email.cz",
        email_required: "Toto pole je povinné",
        email_invalid: "Neplatná e-mailová adresa",
        subject_label: "Předmět",
        subject_placeholder: "Předmět zprávy",
        subject_required: "Předmět je povinný",
        subject_max_length: "Předmět může mít maximálně 100 znaků",
        message_label: "Zpráva *",
        message_placeholder: "Napište nám zprávu...",
        message_required: "Toto pole je povinné",
        message_min_length: "Zpráva musí mít alespoň 10 znaků",
        message_max_length: "Zpráva může mít maximálně 2000 znaků",
        sending: "Odesílám...",
        send_message: "Odeslat zprávu",
        message_sent: "Zpráva odeslána",
        message_sent_desc: "Děkujeme za vaši zprávu. Brzy se vám ozveme zpět.",
        timeout_error: "Vypršel časový limit požadavku. Zkuste to prosím znovu za chvíli.",
        network_error: "Požadavek se nezdařil (síť/CORS). Zkuste to znovu nebo obnovte stránku.",
        general_error: "Něco se pokazilo. Zkuste to prosím znovu později."
      },
      
      // Matches page
      matches: {
        title: "Zápasy",
        all_matches: "Všechny zápasy",
        upcoming_matches: "Nadcházející zápasy",
        past_matches: "Minulé zápasy",
        competition: "Soutěž",
        date: "Datum",
        time: "Čas",
        venue: "Místo",
        result: "Výsledek",
        score: "Skóre",
        report: "Report",
        details: "Detaily",
        no_matches: "Žádné zápasy",
        load_more: "Načíst více",
        show_all: "Zobrazit vše",
        home_team: "Domácí",
        away_team: "Hosté",
        versus: "vs",
        postponed: "Přeloženo",
        oldest_first: "Nejstarší první",
        newest_first: "Nejnovější první",
        no_matches_to_display: "Žádné zápasy k zobrazení",
        check_club_settings: "Zkontrolujte nastavení klubu v administraci",
        played: "Odehráno",
        upcoming: "Nadcházející",
        load_more_matches: "Načíst další zápasy",
        showing_matches: "Zobrazeno {shown} z {total} zápasů",
        win: "Výhra",
        draw: "Remíza",
        loss: "Prohra",
        all_categories: "Všechny kategorie",
        cancelled: "Zrušeno"
      },
      
      // Gallery page
      gallery: {
        no_albums: "Zatím nejsou k dispozici žádná alba",
        albums_will_appear: "Alba se zde zobrazí po jejich načtení ze Zonerama.",
        loading_albums: "Načítám alba...",
        error_loading_albums: "Nepodařilo se načíst alba",
        page_title: "Photos",
        page_description: "Prohlédněte si alba a fotografie našeho klubu.",
        photos_count: "{{count}} fotografií",
        photos_count_one: "{{count}} fotografie",
        photos_count_few: "{{count}} fotografie",
        photos_count_many: "{{count}} fotografií",
        photos_count_other: "{{count}} fotografií",
        views_count: "{{count}} zhlédnutí",
        views_count_one: "{{count}} zhlédnutí",
        views_count_few: "{{count}} zhlédnutí",
        views_count_many: "{{count}} zhlédnutí",
        views_count_other: "{{count}} zhlédnutí",
        show_more_on_zonerama: "Zobrazit na Zonerama",
        latest_albums: "Nejnovější alba z našich akcí",
        view_all_albums: "Zobrazit všechna alba",
        // Album detail page
        album_not_found: "Album nenalezeno",
        error_loading_album: "Chyba při načítání alba",
        back_to_gallery: "Zpět na galerii",
        loading_album: "Načítám album...",
        view_on_zonerama: "Zobrazit na Zonerama",
        photos_from_zonerama: "📸 Všechny fotografie jsou z platformy Zonerama",
        no_photos_in_album: "V tomto albu nejsou žádné fotografie.",
        // Photo modal
        view_original: "Zobrazit originál",
        photo_modal_title: "Fotka"
      },
      
      // Authentication
      auth: {
        login: "Přihlásit se",
        register: "Registrovat se",
        logout: "Odhlásit",
        forgot_password: "Zapomněli jste heslo?",
        reset_password: "Obnovit heslo",
        change_password: "Změnit heslo",
        profile: "Profil",
        account: "Účet",
        sign_in: "Přihlásit se",
        sign_up: "Registrovat se",
        sign_out: "Odhlásit se",
        email: "E-mail",
        password: "Heslo",
        confirm_password: "Potvrdit heslo",
        old_password: "Staré heslo",
        new_password: "Nové heslo",
        remember_me: "Zapamatovat si mě",
        already_have_account: "Již máte účet?",
        dont_have_account: "Nemáte účet?",
        create_account: "Vytvořit účet",
        login_required: "Vyžadováno přihlášení",
        invalid_credentials: "Neplatné přihlašovací údaje",
        session_expired: "Relace vypršela"
      },
      
      // Common words
      common: {
        welcome_message: "Vítejte v našem fotbalovém klubu",
        welcome_subtitle: "Oficiální stránky fotbalového klubu",
        club: "Klub",
        team: "Tým",
        player: "Hráč",
        players: "Hráči",
        coach: "Trenér",
        staff: "Tým",
        match: "Zápas",
        matches: "Zápasy",
        season: "Sezóna",
        competition: "Soutěž",
        league: "Liga",
        cup: "Pohár",
        tournament: "Turnaj",
        training: "Trénink",
        event: "Akce",
        events: "Akce",
        news: "Aktuality",
        article: "Článek",
        articles: "Články",
        gallery: "Galerie",
        photo: "Fotka",
        photos: "Fotky",
        video: "Video",
        videos: "Videa",
        sponsor: "Sponzor",
        sponsors: "Sponzoři",
        partner: "Partner",
        partners: "Partneři",
        fan: "Fanoušek",
        fans: "Fanoušci",
        member: "Člen",
        members: "Členové",
        contact: "Kontakt",
        address: "Adresa",
        phone: "Telefon",
        email: "E-mail",
        website: "Webové stránky",
        facebook: "Facebook",
        instagram: "Instagram",
        youtube: "YouTube",
        twitter: "Twitter",
        linkedin: "LinkedIn",
        date: "Datum",
        time: "Čas",
        place: "Místo",
        result: "Výsledek",
        score: "Skóre",
        goals: "Góly",
        points: "Body",
        position: "Pozice",
        rank: "Pořadí",
        table: "Tabulka",
        standings: "Tabulka",
        schedule: "Program",
        calendar: "Kalendář",
        archive: "Archiv",
        history: "Historie",
        statistics: "Statistiky",
        stats: "Statistiky",
        profile: "Profil",
        settings: "Nastavení",
        account: "Účet",
        user: "Uživatel",
        users: "Uživatelé",
        admin: "Administrátor",
        role: "Role",
        permission: "Oprávnění",
        login: "Přihlášení",
        logout: "Odhlášení",
        password: "Heslo",
        register: "Registrace",
        signup: "Registrace",
        signin: "Přihlášení",
        signout: "Odhlášení",
        forgot_password: "Zapomněli jste heslo?",
        reset_password: "Obnovit heslo",
        change_password: "Změnit heslo",
        old_password: "Staré heslo",
        new_password: "Nové heslo",
        confirm_password: "Potvrdit heslo",
        first_name: "Jméno",
        last_name: "Příjmení",
        full_name: "Celé jméno",
        name: "Název",
        title: "Název",
        description: "Popis",
        content: "Obsah",
        category: "Kategorie",
        categories: "Kategorie",
        tag: "Štítek",
        tags: "Štítky",
        image: "Obrázek",
        images: "Obrázky",
        file: "Soubor",
        files: "Soubory",
        link: "Odkaz",
        url: "URL",
        read_time: "min čtení",
        price: "Cena",
        cost: "Cena",
        amount: "Částka",
        quantity: "Množství",
        size: "Velikost",
        weight: "Váha",
        color: "Barva",
        colors: "Barvy",
        type: "Typ",
        types: "Typy",
        status: "Stav",
        active: "Aktivní",
        inactive: "Neaktivní",
        enabled: "Povoleno",
        disabled: "Zakázáno",
        visible: "Viditelný",
        hidden: "Skrytý",
        public: "Veřejný",
        private: "Soukromý",
        published: "Publikováno",
        draft: "Koncept",
        featured: "Doporučené",
        new: "Nové",
        old: "Staré",
        latest: "Nejnovější",
        popular: "Populární",
        recommended: "Doporučené",
        all: "Vše",
        none: "Žádný",
        other: "Ostatní",
        more: "Více",
        less: "Méně",
        show: "Zobrazit",
        hide: "Skrýt",
        expand: "Rozbalit",
        collapse: "Sbalit",
        search: "Hledat",
        filter: "Filtr",
        sort: "Seřadit",
        order: "Pořadí",
        ascending: "Vzestupně",
        descending: "Sestupně",
        first: "První",
        last: "Poslední",
        next: "Další",
        previous: "Předchozí",
        page: "Stránka",
        pages: "Stránky",
        total: "Celkem",
        count: "Počet",
        number: "Číslo",
        index: "Index",
        id: "ID",
        code: "Kód",
        key: "Klíč",
        value: "Hodnota",
        data: "Data",
        info: "Informace",
        details: "Detaily",
        summary: "Shrnutí",
        overview: "Přehled",
        list: "Seznam",
        grid: "Mřížka",
        graph: "Graf",
        map: "Mapa",
        location: "Lokace",
        country: "Země",
        region: "Region",
        district: "Okres",
        zip: "PSČ",
        street: "Ulice",
        building: "Budova",
        floor: "Patro",
        room: "Místnost",
        stadium: "Stadion",
        field: "Hřiště",
        pitch: "Hřiště",
        locker_room: "Šatna",
        office: "Kancelář",
        shop: "Obchod",
        store: "Obchod",
        restaurant: "Restaurace",
        cafe: "Kavárna",
        parking: "Parkoviště",
        entrance: "Vchod",
        exit: "Východ",
        emergency_exit: "Nouzový východ",
        toilet: "Toaleta",
        wc: "WC",
        men: "Muži",
        women: "Ženy",
        accessible: "Bezbariérový",
        wheelchair: "Invalidní vozík",
        elevator: "Výtah",
        stairs: "Schody",
        ramp: "Rampa",
        door: "Dveře",
        window: "Okno",
        roof: "Střecha",
        wall: "Zeď",
        floor_surface: "Podlaha",
        ceiling: "Strop",
        lighting: "Osvětlení",
        heating: "Topení",
        cooling: "Chlazení",
        ventilation: "Větrání",
        security: "Bezpečnost",
        safety: "Bezpečnost",
        fire_safety: "Požární bezpečnost",
        first_aid: "První pomoc",
        emergency: "Nouzové",
        warning: "Varování",
        danger: "Nebezpečí",
        caution: "Opatrně",
        notice: "Oznámení",
        information: "Informace",
        help: "Pomoc",
        support: "Podpora",
        tiktok: "TikTok",
        snapchat: "Snapchat",
        pinterest: "Pinterest",
        reddit: "Reddit",
        whatsapp: "WhatsApp",
        telegram: "Telegram",
        signal: "Signal",
        viber: "Viber",
        messenger: "Messenger",
        skype: "Skype",
        zoom: "Zoom",
        teams: "Teams",
        slack: "Slack",
        discord: "Discord",
        github: "GitHub",
        gitlab: "GitLab",
        bitbucket: "Bitbucket",
        language: "Jazyk",
        my_account: "Můj účet"
      },
      
      // Engagement system
      engagement: {
        level: "Úroveň",
        points: "bodů",
        progress: "Progres",
        achievements: "Úspěchy",
        rewards: "Odměny"
      },
      
      // Newsletter
      newsletter: {
        email_preferences: "E-mailové preference",
        subscribe: "Přihlaste se k odběru novinek",
        subscribe_description: "Budeme vás informovat o novinkách, zápasech a akcích našeho klubu. Současně pro vás vytvoříme fanouškovský účet a pošleme heslo e‑mailem.",
        email_label: "Váš e-mail",
        consent_text: "Odesláním formuláře souhlasíte se zpracováním osobních údajů. Z odběru se můžete kdykoli odhlásit a nastavení upravit v zaslaném e‑mailu. Heslo lze změnit přes stránku pro obnovení hesla.",
        subscribe_button: "Odeslat",
        subscribe_success: "Přihlášení k odběru proběhlo úspěšně",
        subscribe_success_desc: "Vytvořili jsme vám fanouškovský účet a poslali e‑mail s heslem a odkazy pro správu newsletteru.",
        subscribe_error: "Chyba",
        subscribe_error_desc: "Nastala chyba při přihlašování k odběru",
        email_required: "E-mail je povinný",
        email_invalid: "Neplatná e-mailová adresa",
        loading: "Odesílám..."
      },
      
      // Admin
      admin: {
        page_settings: "Nastavení stránky"
      },
      
      // About page
      about: {
        page_not_setup: "Tato stránka ještě není nastavena. Zde je přehled klubu, soutěží a rubrik.",
        matches_by_competition: "Zápasy podle soutěží",
        club_info: "Oficiální informace o klubu",
        meta_description: "Informace o našem klubu, soutěžích, nadcházejících zápasech a rubrikách."
      }
    }
  },
  en: {
    translation: {
      // Navigation
      nav: {
        home: "Home",
        matches: "Matches",
        calendar: "Calendar",
        tables: "Tables",
        players: "Players",
        gallery: "Photo Gallery",
        videos: "Videos",
        articles: "Articles",
        activities: "Activities",
        contact: "Contact",
        shop: "E-shop",
        sponsors: "Sponsors",
        club: "Club",
        news: "News",
        all_articles: "More articles",
        all_matches: "All matches",
        all_tables: "View all",
        login: "Login",
        register: "Register",
        admin: "Admin",
        logout: "Logout",
        view_all: "View all"
      },
      
      // Homepage sections
      homepage: {
        nearest_matches: "Next matches",
        latest_news: "Latest news",
        latest_title: "Latest title",
        more_articles_home: "More articles",
        tables: "Tables",
        gallery: "Photo gallery",
        sponsors: "Partners",
        shop: "Fanshop",
        calendar: "Calendar",
        activities: "Activities",
        videos: "Videos",
        club: "Club",
        contact: "Contact",
        welcome_to_club: "Welcome to our football club",
        official_website: "Official club website",
        read_more: "Read more",
        view_all: "View all",
        next_match: "Next match",
        match_details: "Match details",
        competition: "Competition",
        venue: "Venue",
        result: "Result",
        standings: "Standings",
        position: "Pos.",
        team: "Team",
        points: "Points",
        played: "Played",
        won: "W",
        drawn: "D",
        lost: "L",
        goals: "Goals",
        goal_difference: "Diff",
        latest_results: "Latest results",
        upcoming_events: "Upcoming events",
        featured_articles: "Featured articles",
        more_articles: "More articles",
        photo_gallery: "Photo gallery",
        video_gallery: "Video gallery",
        our_partners: "Our partners",
        more_videos: "More videos",
        all_matches: "All matches",
        partner_categories: {
          general: "General partner",
          main: "Main partner",
          official: "Official partner",
          media: "Media partner",
          technical: "Technical partner",
          supplier: "Supplier"
        }
      },
      
      // News section
      news: {
        no_news: "No news available yet.",
        view_all_news: "View all articles"
      },
      
      // Common actions
      action: {
        save: "Save",
        edit: "Edit",
        delete: "Delete",
        add: "Add",
        create: "Create",
        update: "Update",
        cancel: "Cancel",
        confirm: "Confirm",
        close: "Close",
        back: "Back",
        next: "Next",
        previous: "Previous",
        search: "Search",
        filter: "Filter",
        sort: "Sort",
        loading: "Loading...",
        error: "Error",
        success: "Success",
        warning: "Warning",
        info: "Info",
        view: "View",
        download: "Download",
        upload: "Upload",
        share: "Share",
        copy: "Copy",
        send: "Send",
        submit: "Submit",
        reset: "Reset",
        refresh: "Refresh",
        open: "Open",
        close_window: "Close window",
        continue: "Continue",
        finish: "Finish",
        start: "Start",
        stop: "Stop",
        pause: "Pause",
        resume: "Resume",
        select: "Select",
        choose: "Choose",
        clear: "Clear",
        apply: "Apply",
        ok: "OK",
        yes: "Yes",
        no: "No",
        more: "More",
        open_menu: "Open menu",
        content_admin: "Content Admin",
        play: "Play",
        open_on_youtube: "Open on YouTube"
      },
      
      // Messages and notifications
      message: {
        loading: "Loading...",
        saving: "Saving...",
        saved: "Saved",
        deleted: "Deleted",
        updated: "Updated",
        created: "Created",
        error_occurred: "An error occurred",
        success_message: "Operation completed successfully",
        confirm_delete: "Are you sure you want to delete this item?",
        no_data_found: "No data found",
        network_error: "Network error",
        server_error: "Server error",
        validation_error: "Validation error",
        permission_denied: "Access denied",
        page_not_found: "Page not found",
        session_expired: "Session expired",
        login_required: "Login required",
        invalid_credentials: "Invalid credentials",
        email_sent: "Email sent",
        email_error: "Error sending email",
        file_uploaded: "File uploaded",
        file_error: "Error uploading file",
        image_uploaded: "Image uploaded",
        image_error: "Error uploading image"
      },
      
      // Footer
      footer: {
        articles: "Articles",
        matches: "Matches",
        table: "Table",
        sponsors: "Sponsors",
        contact: "Contact",
        cookies: "Cookies",
        terms: "Terms of Service",
        privacy: "Privacy Policy",
        eshop: "E‑shop",
        partners: "Our Partners",
        follow_us: "Follow Us",
        copyright: "© {year} {club}. All rights reserved.",
        all_rights_reserved: "All rights reserved {year}",
        powered_by: "Powered by MyClub",
        powered_by_desc: "Professional websites for sports clubs",
        order_now: "Order Now",
        learn_more: "Learn More",
        quick_links: "Quick Links",
        contact_info: "Contact Information",
        address: "Address",
        phone: "Phone",
        email: "Email",
        opening_hours: "Opening Hours"
      },
      
      // Search page
      search: {
        title: "Search",
        description: "Search clubs, matches, articles, players, events and more content",
        placeholder: "Search clubs, matches, articles, players, events...",
        search_button: "Search",
        search_error: "Search error",
        error_title: "Search error",
        no_results: "No results",
        no_results_desc: "No results found for query \"{query}\"",
        try_different: "Try different keywords or search for more general terms",
        search_hint: "Enter keywords to search",
        loading: "Searching...",
        all: "All",
        clubs: "Clubs",
        matches: "Matches",
        articles: "Articles",
        players: "Players",
        events: "Events",
        others: "Others",
        upcoming_matches: "Upcoming Matches",
        past_matches: "Past Matches",
        show_all_clubs: "Show all {count} clubs",
        show_all_players: "Show all {count} players",
        show_all_matches: "Show all matches",
        show_all_articles: "Show all {count} articles",
        show_all_events: "Show all events",
        no_clubs_found: "No clubs found",
        no_matches_found: "No matches found",
        no_articles_found: "No articles found",
        no_players_found: "No players found",
        no_events_found: "No events found",
        no_sponsors_found: "No sponsors found",
        no_contacts_found: "No contacts found",
        no_gallery_found: "No gallery found",
        no_categories_found: "No categories found",
        teams: "Teams",
        sponsors: "Sponsors",
        contacts: "Contacts",
        gallery: "Gallery",
        photos: "photos",
        no_other_results: "No other results"
      },
      
      // Tables page
      tables: {
        title: "Tables",
        subtitle: "Official FACR tables by competition.",
        loading: "Loading tables…",
        no_tables: "No tables available for this club.",
        schedule_link: "Schedule and competition details",
        rank: "#",
        team: "Team",
        played: "P",
        wins: "W",
        draws: "D",
        losses: "L",
        score: "Score",
        points: "Points",
        position_place: "{{position}}. place",
        select_club: "Select a club to view competition table.",
        loading_table: "Loading table...",
        table_error: "Error loading table"
      },
      
      // Club modal
      club_modal: {
        statistics: "Statistics",
        matches_played: "Matches Played",
        wins: "Wins",
        draws: "Draws",
        losses: "Losses",
        score: "Score",
        goals_scored: "Goals Scored",
        goals_conceded: "Goals Conceded",
        goal_difference: "Goal Difference",
        points: "Points",
        form_last_5: "Form (Last 5 Matches)",
        close: "Close"
      },
      
      // Calendar page
      calendar: {
        title: "Calendar",
        subtitle: "Overview of matches by competition (FACR).",
        loading: "Loading schedule...",
        no_matches: "No matches to display yet.",
        check_settings: "Check club settings in administration",
        all_competitions: "All Matches",
        month_view: "Month View",
        week_view: "Week View",
        today: "Today",
        no_events: "No Events",
        match: "Match",
        event: "Event",
        training: "Training",
        competition: "Competition",
        venue: "Venue",
        result: "Result",
        upcoming: "Upcoming",
        past: "Past",
        activities_title: "Activities",
        activities_subtitle: "Training calendar, meetings and other club activities.",
        all_types: "All Types",
        no_activities: "No activities to display yet.",
        oldest_first: "Oldest First",
        list_view: "List",
        calendar_view: "Calendar",
        club: "Club",
        matches_filter: "Matches",
        training_filter: "Training", 
        meeting_filter: "Meetings",
        other_filter: "Other",
        previous_month: "Previous Month",
        next_month: "Next Month",
        loading_activities: "Loading activities…",
        match_type: "Match",
        training_type: "Training",
        meeting_type: "Meeting",
        other_type: "Other",
        more_events: "+{count} more…",
        win: "Win",
        draw: "Draw", 
        loss: "Loss",
        show_more: "+{count} more…",
        show_less: "Show Less",
        show_past_matches: "Show Past Matches ({count})",
        hide_past_matches: "Hide Past Matches",
      },
      
      // Players page
      players: {
        title: "Players",
        search_placeholder: "Search name, number, position",
        gender: "Gender",
        position: "Position",
        active_only: "Active only",
        male: "Male",
        female: "Female",
        loading_error: "Error loading players"
      },
      
      // Blog page
      blog: {
        title: "Blog",
        search_articles: "Search articles…",
        search_match: "Search match…",
        all_categories: "All Categories",
        loading: "Loading…",
        category: "Category",
        publish_date: "Publish Date",
        read_time: "Read Time",
        search_results: "Search results for articles „{query}“.",
        category_articles: "Articles in category {category}.",
        latest_articles: "Latest articles, reviews and news from the club.",
        match: "Match",
        subscribe: "Subscribe to newsletter",
        subscribe_description: "We will inform you about news, matches and events of our club. We will also create a fan account for you and send a password by email.",
        email_label: "Your email",
        consent_text: "By submitting the form you agree to the processing of personal data. You can unsubscribe at any time and adjust the settings in the sent email. Password can be changed via the password recovery page.",
        subscribe_button: "Subscribe"
      },
      
      // Videos page
      videos: {
        title: "Videos",
        description: "Watch our latest videos and matches.",
        loading: "Loading videos...",
        watch_latest: "Watch our latest videos and matches",
        all_from_youtube: "All videos are from YouTube",
        no_videos: "No videos available yet",
        play: "Play",
        youtube_channel: "YouTube Channel",
        open_on_youtube: "Open on YouTube",
        more_videos: "More videos"
      },
      
      // Sponsors page
      sponsors: {
        title: "Our Partners",
        main_partners: "Main Partners",
        partners: "Partners",
        become_partner: "Become a Club Partner",
        partnership_description: "Interested in cooperation, advertising or club support? Write us some information and we'll get back to you.",
        name_label: "Name and Surname *",
        name_placeholder: "John Doe",
        name_required: "Please fill in your name",
        email_label: "E‑mail *",
        email_placeholder: "your@email.com",
        email_required: "Please fill in your e‑mail",
        subject_label: "Subject *",
        subject_placeholder: "Partnership, advertising, support...",
        subject_required: "Subject is required",
        message_label: "Message *",
        message_placeholder: "Briefly write us what kind of cooperation you're interested in...",
        message_required: "Please write a short message",
        sending: "Sending...",
        send_message: "Send Message",
        message_sent: "Message Sent",
        message_sent_desc: "Thank you for your message.",
        error_loading: "Error loading sponsors",
        timeout_error: "Request timed out. Please try again.",
        network_error: "Request failed (network/CORS). Refresh page and try again.",
        send_error: "Sending failed",
        error_title: "Error"
      },
      
      // Contact page
      contact: {
        title: "Contact",
        contact_info: "Contact Information",
        address: "Address",
        phone: "Phone",
        email: "Email",
        contact_persons: "Contact Persons",
        others: "Others",
        no_contacts: "No contact person for this category yet.",
        contact_us: "Contact Us",
        contact_description: "Have a question or comment? Write us a message and we'll get back to you as soon as possible.",
        name_label: "Name and Surname *",
        name_placeholder: "John Doe",
        name_required: "This field is required",
        name_min_length: "Name must be at least 2 characters",
        email_label: "Email Address *",
        email_placeholder: "your@email.com",
        email_required: "This field is required",
        email_invalid: "Invalid email address",
        subject_label: "Subject",
        subject_placeholder: "Message subject",
        subject_required: "Subject is required",
        subject_max_length: "Subject can be maximum 100 characters",
        message_label: "Message *",
        message_placeholder: "Write us a message...",
        message_required: "This field is required",
        message_min_length: "Message must be at least 10 characters",
        message_max_length: "Message can be maximum 2000 characters",
        sending: "Sending...",
        send_message: "Send Message",
        message_sent: "Message Sent",
        message_sent_desc: "Thank you for your message. We'll get back to you soon.",
        timeout_error: "Request timed out. Please try again in a moment.",
        network_error: "Request failed (network/CORS). Try again or refresh page.",
        general_error: "Something went wrong. Please try again later."
      },
      
      // Matches page
      matches: {
        title: "Matches",
        all_matches: "All Matches",
        upcoming_matches: "Upcoming Matches",
        past_matches: "Past Matches",
        competition: "Competition",
        date: "Date",
        time: "Time",
        venue: "Venue",
        result: "Result",
        score: "Score",
        report: "Report",
        details: "Details",
        no_matches: "No Matches",
        load_more: "Load More",
        show_all: "Show All",
        home_team: "Home",
        away_team: "Away",
        versus: "vs",
        postponed: "Postponed",
        oldest_first: "Oldest First",
        newest_first: "Newest First",
        no_matches_to_display: "No matches to display",
        check_club_settings: "Check club settings in administration",
        played: "Played",
        upcoming: "Upcoming",
        load_more_matches: "Load more matches",
        showing_matches: "Showing {shown} of {total} matches",
        win: "Win",
        draw: "Draw",
        loss: "Loss",
        all_categories: "All Categories",
        cancelled: "Cancelled"
      },
      
      // Gallery page
      gallery: {
        no_albums: "No albums available yet",
        albums_will_appear: "Albums will appear here after loading from Zonerama.",
        loading_albums: "Loading albums...",
        error_loading_albums: "Failed to load albums",
        page_title: "Photo Gallery",
        page_description: "Browse albums and photos of our club.",
        photos_count: "{{count}} photos",
        photos_count_one: "{{count}} photo",
        photos_count_few: "{{count}} photos",
        photos_count_many: "{{count}} photos",
        photos_count_other: "{{count}} photos",
        views_count: "{{count}} views",
        views_count_one: "{{count}} view",
        views_count_few: "{{count}} views",
        views_count_many: "{{count}} views",
        views_count_other: "{{count}} views",
        show_more_on_zonerama: "Show more on Zonerama",
        latest_albums: "Latest albums from our events",
        view_all_albums: "View all albums",
        // Album detail page
        album_not_found: "Album not found",
        error_loading_album: "Error loading album",
        back_to_gallery: "Back to gallery",
        loading_album: "Loading album...",
        view_on_zonerama: "View on Zonerama",
        photos_from_zonerama: "📸 All photos are from Zonerama platform",
        no_photos_in_album: "There are no photos in this album.",
        // Photo modal
        view_original: "View original",
        photo_modal_title: "Photo"
      },
      
      // Authentication
      auth: {
        login: "Login",
        register: "Register",
        logout: "Logout",
        forgot_password: "Forgot Password?",
        reset_password: "Reset Password",
        change_password: "Change Password",
        profile: "Profile",
        account: "Account",
        sign_in: "Sign In",
        sign_up: "Sign Up",
        sign_out: "Sign Out",
        email: "Email",
        password: "Password",
        confirm_password: "Confirm Password",
        old_password: "Old Password",
        new_password: "New Password",
        remember_me: "Remember Me",
        already_have_account: "Already have an account?",
        dont_have_account: "Don't have an account?",
        create_account: "Create Account",
        login_required: "Login Required",
        invalid_credentials: "Invalid Credentials",
        session_expired: "Session Expired"
      },
      
      // Common words
      common: {
        welcome_message: "Welcome to our football club",
        welcome_subtitle: "Official website of the football club",
        club: "Club",
        team: "Team",
        player: "Player",
        players: "Players",
        coach: "Coach",
        staff: "Staff",
        match: "Match",
        matches: "Matches",
        season: "Season",
        competition: "Competition",
        league: "League",
        cup: "Cup",
        tournament: "Tournament",
        training: "Training",
        event: "Event",
        events: "Events",
        news: "News",
        article: "Article",
        articles: "Articles",
        gallery: "Gallery",
        photo: "Photo",
        photos: "Photos",
        video: "Video",
        videos: "Videos",
        sponsor: "Sponsor",
        sponsors: "Sponsors",
        partner: "Partner",
        partners: "Partners",
        fan: "Fan",
        fans: "Fans",
        member: "Member",
        members: "Members",
        contact: "Contact",
        address: "Address",
        phone: "Phone",
        email: "Email",
        website: "Website",
        facebook: "Facebook",
        instagram: "Instagram",
        youtube: "YouTube",
        twitter: "Twitter",
        linkedin: "LinkedIn",
        date: "Date",
        time: "Time",
        place: "Place",
        result: "Result",
        score: "Score",
        goals: "Goals",
        points: "Points",
        position: "Position",
        rank: "Rank",
        table: "Table",
        standings: "Standings",
        schedule: "Schedule",
        calendar: "Calendar",
        archive: "Archive",
        history: "History",
        statistics: "Statistics",
        stats: "Stats",
        profile: "Profile",
        settings: "Settings",
        account: "Account",
        user: "User",
        users: "Users",
        admin: "Admin",
        role: "Role",
        permission: "Permission",
        login: "Login",
        logout: "Logout",
        password: "Password",
        register: "Register",
        signup: "Sign up",
        signin: "Sign in",
        signout: "Sign out",
        forgot_password: "Forgot password?",
        reset_password: "Reset password",
        change_password: "Change password",
        old_password: "Old password",
        new_password: "New password",
        confirm_password: "Confirm password",
        first_name: "First name",
        last_name: "Last name",
        full_name: "Full name",
        name: "Name",
        title: "Title",
        description: "Description",
        content: "Content",
        category: "Category",
        categories: "Categories",
        tag: "Tag",
        tags: "Tags",
        image: "Image",
        images: "Images",
        file: "File",
        files: "Files",
        link: "Link",
        url: "URL",
        read_time: "min read",
        price: "Price",
        cost: "Cost",
        amount: "Amount",
        quantity: "Quantity",
        size: "Size",
        weight: "Weight",
        color: "Color",
        colors: "Colors",
        type: "Type",
        types: "Types",
        status: "Status",
        active: "Active",
        inactive: "Inactive",
        enabled: "Enabled",
        disabled: "Disabled",
        visible: "Visible",
        hidden: "Hidden",
        public: "Public",
        private: "Private",
        published: "Published",
        draft: "Draft",
        featured: "Featured",
        new: "New",
        old: "Old",
        latest: "Latest",
        popular: "Popular",
        recommended: "Recommended",
        all: "All",
        none: "None",
        other: "Other",
        more: "More",
        less: "Less",
        show: "Show",
        hide: "Hide",
        expand: "Expand",
        collapse: "Collapse",
        search: "Search",
        filter: "Filter",
        sort: "Sort",
        order: "Order",
        ascending: "Ascending",
        descending: "Descending",
        first: "First",
        last: "Last",
        next: "Next",
        previous: "Previous",
        page: "Page",
        pages: "Pages",
        total: "Total",
        count: "Count",
        number: "Number",
        index: "Index",
        id: "ID",
        code: "Code",
        key: "Key",
        value: "Value",
        data: "Data",
        info: "Info",
        details: "Details",
        summary: "Summary",
        overview: "Overview",
        list: "List",
        grid: "Grid",
        graph: "Graph",
        map: "Map",
        location: "Location",
        country: "Country",
        region: "Region",
        district: "District",
        zip: "ZIP",
        street: "Street",
        building: "Building",
        floor: "Floor",
        room: "Room",
        stadium: "Stadium",
        field: "Field",
        pitch: "Pitch",
        locker_room: "Locker room",
        office: "Office",
        shop: "Shop",
        store: "Store",
        restaurant: "Restaurant",
        cafe: "Cafe",
        parking: "Parking",
        entrance: "Entrance",
        exit: "Exit",
        emergency_exit: "Emergency exit",
        toilet: "Toilet",
        wc: "WC",
        men: "Men",
        women: "Women",
        accessible: "Accessible",
        wheelchair: "Wheelchair",
        elevator: "Elevator",
        stairs: "Stairs",
        ramp: "Ramp",
        door: "Door",
        window: "Window",
        roof: "Roof",
        wall: "Wall",
        floor_surface: "Floor",
        ceiling: "Ceiling",
        lighting: "Lighting",
        heating: "Heating",
        cooling: "Cooling",
        ventilation: "Ventilation",
        security: "Security",
        safety: "Safety",
        fire_safety: "Fire safety",
        first_aid: "First aid",
        emergency: "Emergency",
        warning: "Warning",
        danger: "Danger",
        caution: "Caution",
        notice: "Notice",
        information: "Information",
        help: "Help",
        support: "Support",
        tiktok: "TikTok",
        snapchat: "Snapchat",
        pinterest: "Pinterest",
        reddit: "Reddit",
        whatsapp: "WhatsApp",
        telegram: "Telegram",
        signal: "Signal",
        viber: "Viber",
        messenger: "Messenger",
        skype: "Skype",
        zoom: "Zoom",
        teams: "Teams",
        slack: "Slack",
        discord: "Discord",
        github: "GitHub",
        gitlab: "GitLab",
        bitbucket: "Bitbucket",
        language: "Language",
        my_account: "My Account"
      },
      
      // Engagement system
      engagement: {
        level: "Level",
        points: "points",
        progress: "Progress",
        achievements: "Achievements",
        rewards: "Rewards"
      },
      
      // Newsletter
      newsletter: {
        email_preferences: "Email Preferences",
        subscribe: "Subscribe to newsletter",
        subscribe_description: "We will inform you about news, matches and events of our club. We will also create a fan account for you and send the password by email.",
        email_label: "Your email",
        consent_text: "By submitting the form you agree to the processing of personal data. You can unsubscribe and manage settings at any time in the email sent. Password can be changed via the password reset page.",
        subscribe_button: "Submit",
        subscribe_success: "Newsletter subscription successful",
        subscribe_success_desc: "We have created a fan account for you and sent an email with password and links for newsletter management.",
        subscribe_error: "Error",
        subscribe_error_desc: "An error occurred while subscribing to newsletter",
        email_required: "Email is required",
        email_invalid: "Invalid email address",
      },
      
      // Admin
      admin: {
        page_settings: "Page settings"
      },
      
      // About page
      about: {
        page_not_setup: "This page is not set up yet. Here is an overview of the club, competitions and categories.",
        matches_by_competition: "Matches by competition",
        club_info: "Official club information",
        meta_description: "Information about our club, competitions, upcoming matches and categories."
      }
    }
  }
};

// Detect language from localStorage, cookie, or browser
const detectLanguage = () => {
  // Try localStorage first
  try {
    const stored = localStorage.getItem('language');
    if (stored && ['cs', 'en'].includes(stored)) {
      return stored;
    }
  } catch (e) {
    // Ignore localStorage errors
  }
  
  // Try cookie
  try {
    const cookies = document.cookie.split(';');
    for (const cookie of cookies) {
      const [name, value] = cookie.trim().split('=');
      if (name === 'lang' && ['cs', 'en'].includes(value)) {
        return value;
      }
    }
  } catch (e) {
    // Ignore cookie errors
  }
  
  // Fallback to browser language or default to Czech
  const browserLang = navigator.language.split('-')[0];
  return ['cs', 'en'].includes(browserLang) ? browserLang : 'cs';
};

i18n
  // Pass i18n down to react-i18next
  .use(initReactI18next)
  // Init i18next
  .init({
    // Detect language from storage or browser
    lng: detectLanguage(),
    fallbackLng: 'cs',
    debug: false,
    
    // Resources
    resources,
    
    // Namespace configuration - simplified to use default namespace
    ns: ['translation'],
    defaultNS: 'translation',
    
    // Interpolation
    interpolation: {
      escapeValue: false, // React already escapes
      formatSeparator: ',',
      format: function(value, format, lng) {
        if (format === 'uppercase') return value.toUpperCase();
        if (format === 'lowercase') return value.toLowerCase();
        if (format === 'currency') return new Intl.NumberFormat(lng, { style: 'currency', currency: 'CZK' }).format(value);
        if (format === 'date') return new Intl.DateTimeFormat(lng).format(new Date(value));
        return value;
      },
    },
    
    // React options
    react: {
      useSuspense: false, // Disable suspense for loading
      bindI18n: 'languageChanged',
      bindI18nStore: 'added removed',
      transEmptyNodeValue: '',
      transSupportBasicHtmlNodes: true,
      transKeepBasicHtmlNodesFor: ['br', 'strong', 'i', 'em', 'span'],
    },
  }).catch(err => {
    console.error('i18n: Initialization failed:', err);
  });

// Add language change listener to save to localStorage
i18n.on('languageChanged', (lng) => {
  try {
    localStorage.setItem('language', lng);
    // Also update cookie for compatibility
    document.cookie = `lang=${lng}; max-age=${365 * 24 * 60 * 60}; path=/`;
  } catch (e) {
    // Ignore storage errors
  }
});

export default i18n;
